import "./scss/global.scss";
import App from './App.svelte';

const app = new App({
	target: document.getElementById("svelte")
});

export default app;